import React, { useEffect, useState, useRef } from 'react'
import './Header.css'
import { connect } from 'react-redux'
import axios from '../../../AxiosConfig'
import Logo from '../../images/SkyQ-Tech-logo.svg'
import { showLeftSidebar } from '../../../features/sidebar/LeftSidebarSlice'
import { setRenderCount, showPreloader } from '../../../features/data/dataSlice'
import { showAddTaskModal } from '../../../features/modal/AddTaskSlice'
import { useNavigate, Link } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'
import Offcanvas from 'react-bootstrap/Offcanvas'
import { EllipsisVertical } from 'lucide-react'

const Header = ({
  showLeftSidebar,
  userData,
  setRenderCount,
  renderCount,
  attendanceListData,
  showPreloader,
  socketConnected
}) => {
  const [userCurrentLocation, setUserCurrentLocation] = useState('')
  const [latLong, setLatLong] = useState(null)
  const [userLoginStatus, setUserLoginStatus] = useState(false)
  let navigate = useNavigate()
  const [isSearchVisible, setIsSearchVisible] = useState(false)
  const searchInputRef = useRef(null)

  const toggleSearchBox = () => {
    setIsSearchVisible(prev => !prev)

    // Focus on the input when search box becomes visible
    if (!isSearchVisible && searchInputRef.current) {
      searchInputRef.current.focus()
    }
  }

  const closeSearchBox = () => {
    setIsSearchVisible(false)
  }

  const [canvas, setCanvas] = useState(false)

  const hadleShowHide = arg1 => {
    setCanvas(arg1)
  }

  const [loggedUser, setLoggedUser] = useState()

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (userInfo) {
      setLoggedUser(userInfo)
    }
  }, [])

  const [fullscreen, setFullscreen] = useState(true)
  const [show, setShow] = useState(false)
  function handleShow() {
    setFullscreen()
    setShow(true)
  }

  // useEffect(() => {
  //   offlineMode()
  //   onlineMode()
  // }, [])

  return (
    <>
      <div
        class="appHeader "
        style={{
          position: 'fixed',
          width: '100%',
          top: '0px',
          zIndex: '100',
          backgroundColor: '#ffffff'
        }}
      >
        <div class="left">
          <Link to="/myprofile" class="headerButton">
            <div
              style={{
                border: socketConnected
                  ? '2px solid #34c759'
                  : '2px solid #ec4433',
                borderRadius: '50%'
              }}
            >
              {loggedUser && (
                <img
                  src={loggedUser.pic}
                  alt="avatar"
                  class="imaged rounded"
                  width={30}
                />
              )}
            </div>
          </Link>
        </div>
        <div class="pageTitle">
          <h2 className="m-0" style={{ fontSize: '15px' }}>
            1st Up
          </h2>
        </div>
        <div class="right">
          {/* <div class="chip chip-outline chip-dark">
            <span
              className={`badge badge-empty position-static ms-1 badge-${
                socketConnected ? 'success' : 'danger'
              }`}
            ></span>
            <span class="chip-label">
              {socketConnected ? 'Online' : 'Offline'}
            </span>
          </div> */}
          {/* <Dropdown className="me-1">
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              <EllipsisVertical />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>
                <Link to="/settings">Settings</Link>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
        </div>
      </div>
    </>
  )
}

const mapStateToProps = ({ auth, data }) => {
  const { userData } = auth
  const { renderCount, attendanceListData, preloaderVisible, socketConnected } =
    data
  return {
    userData,
    renderCount,
    attendanceListData,
    preloaderVisible,
    socketConnected
  }
}

const mapDispatchToProps = {
  showLeftSidebar,
  setRenderCount,
  showAddTaskModal,
  showPreloader
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
